import { EntityStore } from '../../../shared/stores/EntityStore';
import { action, makeObservable } from 'mobx';
import { api } from '../../../shared/api/api';

class SkillStore extends EntityStore {
	constructor() {
		super('skills');
		makeObservable(this);
	}

	@action
	async getSkills(query) {
		const search = query == null ? '' : String(query);
		const url = `${this.entityPluralEndpoint}?q=${encodeURIComponent(search)}`;
		return api.get(url);
	}
}

export const skillStore = new SkillStore();
